var map = {
	"./airbnbLogo.png": 85,
	"./awards/director.jpg": 86,
	"./awards/ieee-svcc.jpg": 87,
	"./awards/makaut.jpg": 88,
	"./awards/spotaward.jpeg": 89,
	"./awards/uspto.jpg": 90,
	"./awards/value-creator.jpg": 91,
	"./contactMail.webp": 92,
	"./contactMailDark.svg": 43,
	"./coursera.png": 93,
	"./developerActivity.svg": 44,
	"./facebookLogo.png": 94,
	"./googleAssistant.svg": 95,
	"./googleAssistantLogo.webp": 96,
	"./harvardLogo.png": 97,
	"./iedc.jpeg": 98,
	"./iemlogo.png": 99,
	"./jsFramework.svg": 100,
	"./keysight-technologies--big.svg": 101,
	"./manOnTable.svg": 102,
	"./nextuLogo.webp": 103,
	"./programmer.svg": 104,
	"./pwa.webp": 105,
	"./pwaLogo.webp": 106,
	"./quoraLogo.png": 107,
	"./rodologo.png": 108,
	"./saayaHealthLogo.webp": 109,
	"./skill.svg": 45,
	"./stanfordLogo.png": 110,
	"./talks/aidevcon.jpg": 111,
	"./talks/cocon2025.jpg": 112,
	"./talks/cocon24.jpg": 113,
	"./talks/icetcsdp.jpg": 114,
	"./talks/ktc-sfo.jpg": 115,
	"./talks/nullcon.jpg": 116,
	"./talks/nullmeet2.jpeg": 117,
	"./talks/rootcon.jpg": 118,
	"./talksCardBack.svg": 119
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 84;